import { faWaveformLines } from '@fortawesome/pro-regular-svg-icons';

import { TUser } from '@cloud-wave/neon-common-lib';

import Icon from '../Icon';

export default function OnCallWaveformIcon({
  onContact,
  className,
}: {
  onContact?: TUser['onContact'];
  className?: string;
}) {
  if (onContact !== 'OnCall') {
    return null;
  }

  return <Icon size={13} tooltip="Agent is currently on a voice call." icon={faWaveformLines} className={className} />;
}
